/**
 * Portal's public/ assets, resolved through the static manifest.
 *
 * Every reference to a file under a PUBLISHED subtree (see
 * scripts/assets/publish-static.mjs) must go through `staticUrl`, because the
 * release artifact no longer carries those files once they are on the CDN — a raw
 * '/landing/…' string would 404 in prod. `shared/__tests__/unit/static.test.ts`
 * fails the build if a raw one appears.
 *
 * Unset NEXT_PUBLIC_STATIC_BASE_URL (dev) → the path is returned untouched.
 */
import { createStaticUrl } from '@owlcat/app-shell/static-assets';
import manifest from '../static-manifest.json';

export const staticUrl = createStaticUrl(manifest as Record<string, string>);
